var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stepBox", class: _vm.className }, [
    _c(
      "div",
      {
        ref: "slider_dom",
        staticClass: "stepBoxLeft",
        class: _vm.slider_dom,
        style: "height: " + _vm.stepPageHeight + "px;",
        on: { scroll: _vm.slider_handleScroll },
      },
      [
        _c(
          "div",
          { ref: "slider_box", staticClass: "slider_box" },
          [_vm._t("default")],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "stepBoxRight" },
      [
        _vm._t("rightBox", null, {
          navActive: _vm.navActive,
          jump: _vm._slider_handleClick,
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }